<template>

</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
    methods: {
        featureLocked(feature) {
            if(!this.user.shipper || !_.isArray(this.user.shipper_features)) {
        return false;
      }

      return this.user.shipper_features.includes(feature);

        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/mixins/Security.vue